"use strict";

exports.__esModule = true;
exports["default"] = createRequest;

var _lodash = require("lodash");

var _urijs = _interopRequireDefault(require("urijs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var appendPetriOvr = function appendPetriOvr(path, petriOvr) {
  if (!petriOvr) {
    return path;
  }

  var uri = new _urijs["default"](path);
  uri.setQuery('petri_ovr', petriOvr);
  return _urijs["default"].decode(uri);
};

function createRequest(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl,
      _ref$getInstance = _ref.getInstance,
      getInstance = _ref$getInstance === void 0 ? function () {
    return null;
  } : _ref$getInstance,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en' : _ref$locale,
      groupId = _ref.groupId,
      cookie = _ref.cookie,
      _ref$performanceTrack = _ref.performanceTracker,
      performanceTracker = _ref$performanceTrack === void 0 ? {
    trackStart: _lodash.noop,
    trackEnd: _lodash.noop
  } : _ref$performanceTrack,
      siteRevision = _ref.siteRevision,
      _ref$trackError = _ref.trackError,
      trackError = _ref$trackError === void 0 ? function () {} : _ref$trackError,
      _ref$logResponse = _ref.logResponse,
      logResponse = _ref$logResponse === void 0 ? function () {} : _ref$logResponse,
      _ref$petriOvr = _ref.petriOvr,
      petriOvr = _ref$petriOvr === void 0 ? '' : _ref$petriOvr;

  var request = function request(path, config) {
    if (config === void 0) {
      config = {};
    }

    var url = appendPetriOvr("" + (0, _lodash.trimEnd)(baseUrl, '/') + path, petriOvr);
    var shouldParseHeaders = config.parseHeaders;
    delete config.parseHeaders;
    var instance = getInstance();

    var headers = _objectSpread({
      instance: instance,
      Authorization: instance,
      locale: locale
    }, config.headers);

    if (cookie) {
      headers.cookie = cookie;
    }

    if (groupId) {
      headers['group-id'] = groupId;
    }

    if (siteRevision) {
      headers['x-wix-site-revision'] = siteRevision;
    }

    (0, _lodash.extend)(config, {
      headers: headers,
      credentials: 'same-origin'
    });
    var marker = performanceTracker.trackStart((config.method || 'GET') + " " + path);

    var shouldRetryOnGatewayTimeout = function shouldRetryOnGatewayTimeout(response) {
      return config.noRetriesOnGatewayTimeout ? response.status !== 504 : true;
    };

    var start = function start() {
      return fetch(url, config);
    };

    var parse = function parse(response) {
      response.__debug = {
        baseUrl: baseUrl,
        path: path,
        instance: instance
      };
      return Promise.resolve(response).then(handleSuccess).then(shouldParseHeaders ? parseHeadersAndBody : parseBody).then(function (r) {
        performanceTracker.trackEnd(marker);
        return r;
      }).then(function (r) {
        var headers = [];

        try {
          if (r && r.headers && r.headers.entries) {
            for (var _iterator = _createForOfIteratorHelperLoose(r.headers.entries()), _step; !(_step = _iterator()).done;) {
              var h = _step.value;
              headers.push(h);
            }
          } else if (r && r.headers) {
            headers.push(JSON.stringify(r.headers));
          }
        } catch (error) {
          trackError(error);
        }

        logResponse([path, r && r.body ? r.body : r, headers]);
        return r;
      })["catch"](function (error) {
        trackError("request error: path=" + path + ", status=" + (0, _lodash.get)(error, 'status') + ", error=" + JSON.stringify(error));
        return Promise.reject(error);
      });
    };

    var sleep = function sleep(timeout) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, timeout);
      });
    };

    var retry = function retry(fn, retries, timeout) {
      if (retries === void 0) {
        retries = 3;
      }

      if (timeout === void 0) {
        timeout = 300;
      }

      return new Promise(function (resolve, reject) {
        return fn().then(function (response) {
          if (response.status >= 500 && retries > 1 && shouldRetryOnGatewayTimeout(response)) {
            return sleep(timeout).then(function () {
              return retry(fn, retries - 1, timeout * 2);
            }).then(resolve, reject);
          }

          resolve(response);
        }, function (error) {
          if (retries > 1) {
            return sleep(timeout).then(function () {
              return retry(fn, retries - 1, timeout * 2);
            }).then(resolve, reject);
          }

          reject(error);
        });
      });
    };

    return retry(start).then(parse);
  };

  request.post = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request.put = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request.patch = function (path, data, config) {
    return request(path, (0, _lodash.merge)({}, config, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }));
  };

  request["delete"] = function (path, config) {
    return request(path, (0, _lodash.extend)({}, config, {
      method: 'DELETE'
    }));
  };

  request.uploadFile = function (file, credentials) {
    var formData = new FormData();
    formData.append('file', file);
    formData.append('media_type', 'picture');
    formData.append('upload_token', credentials.uploadToken);
    formData.append('parent_folder_id', credentials.folderId);
    var config = {
      method: 'POST',
      body: formData
    };
    return fetch(credentials.uploadUrl, config).then(handleSuccess).then(parseBody);
  };

  return request;
}

function handleSuccess(response) {
  var status = response.status;

  if (status < 400) {
    return response;
  }

  return Promise.reject(response);
}

function parseBody(response) {
  return response.json()["catch"](function () {
    return Promise.resolve();
  }); // catch is incase it's not json
}

function parseHeadersAndBody(response) {
  return response.json().then(function (data) {
    return {
      body: data,
      headers: response.headers
    };
  })["catch"](function () {
    return Promise.resolve();
  }); // catch is incase it's not json
}